import { ITemplatesModuloInterface } from "../../../Interfaces/Geral/TemplatesModulo/TemplatesModuloInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetTemplatesPorModulosServices(idTipoCaso: number) {
    return Service(
        Axios.get<Array<ITemplatesModuloInterface>>(
            `/home/documentos/listardocumentotemplate?idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function GetTemplatesServices(idTipoCaso: number, flNaoCarregaTemplate: boolean) {
    return Service(
        Axios.get<Array<ITemplatesModuloInterface>>(
            `/home/documentos/listardocumentotemplate?idTipoCaso=${idTipoCaso}&FL_NAO_CARREGA_TEMPLATE=${flNaoCarregaTemplate}`
        )
    );
}

export async function GetTemplatesDesvinculadosPorModulosServices(
    idModulo: number
) {
    return Service(
        Axios.get<Array<ITemplatesModuloInterface>>(
            `/home/documentos/listardocumentotemplatedesvinculadospormodulo?idModulo=${idModulo}`
        )
    );
}

export async function DesvincularTemplateModuloService(
    idDocumentoTemplateModulo: number[]
) {
    return Service(
        Axios.put(
            `/home/documentos/desvinculartemplatemodulo`,
            idDocumentoTemplateModulo
        )
    );
}

export async function VincularTemplateModuloTelaService(
    idTipoCaso: number,
    idDocumentoTemplate: number[]
) {
    return Service(
        Axios.post(
            `/home/documentos/vinculartemplatemodulo?idTipoCaso=${idTipoCaso}`,
            idDocumentoTemplate
        )
    );
}
